import SystemEnum from '@/assets/js/systemEnum'
import DataType from '@/util/dataType'
const WORK_QUEUE = SystemEnum.THIRD_QUEUE_ENUM
const THIRD_QUEUE = [
  {
    status: WORK_QUEUE.PENDING_WA.value,
    title: WORK_QUEUE.PENDING_WA.text,
    key: WORK_QUEUE.PENDING_WA.key,
    features: WORK_QUEUE.PENDING_WA.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#5C82E3', '#F2F5FD'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.WA.value,
    title: WORK_QUEUE.WA.text,
    key: WORK_QUEUE.WA.key,
    features: WORK_QUEUE.WA.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#EAA0C8', '#FEFAFC'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.WA_PAID_OFF.value,
    title: WORK_QUEUE.WA_PAID_OFF.text,
    key: WORK_QUEUE.WA_PAID_OFF.key,
    features: WORK_QUEUE.WA_PAID_OFF.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#64CA99', '#EFFFF7'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PENDING_WAI.value,
    title: WORK_QUEUE.PENDING_WAI.text,
    key: WORK_QUEUE.PENDING_WAI.key,
    features: WORK_QUEUE.PENDING_WAI.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#5C82E3', '#F2F5FD'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  // {
  //   status: WORK_QUEUE.WAI_POCKETED.value,
  //   title: WORK_QUEUE.WAI_POCKETED.text,
  //   key: WORK_QUEUE.WAI_POCKETED.key,
  //   features: WORK_QUEUE.WAI.features,
  //   code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
  //   color: ['#EAA0C8', '#FEFAFC'],
  //   count: 0,
  //   items: [],
  //   indexOfPage: 1,
  //   isEnd: true,
  //   isLoading: true
  // },
  {
    status: WORK_QUEUE.WAI.value,
    title: WORK_QUEUE.WAI.text,
    key: WORK_QUEUE.WAI.key,
    features: WORK_QUEUE.WAI.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#EAA0C8', '#FEFAFC'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.WAI_PAID_OFF.value,
    title: WORK_QUEUE.WAI_PAID_OFF.text,
    key: WORK_QUEUE.WAI_PAID_OFF.key,
    features: WORK_QUEUE.WAI_PAID_OFF.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#64CA99', '#EFFFF7'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.THIRD_PARTY.value,
    title: WORK_QUEUE.THIRD_PARTY.text,
    key: WORK_QUEUE.THIRD_PARTY.key,
    features: WORK_QUEUE.THIRD_PARTY.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#EAA0C8', '#FEFAFC'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.THIRD_PARTY_PAID_OFF.value,
    title: WORK_QUEUE.THIRD_PARTY_PAID_OFF.text,
    key: WORK_QUEUE.THIRD_PARTY_PAID_OFF.key,
    features: WORK_QUEUE.THIRD_PARTY_PAID_OFF.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['#64CA99', '#EFFFF7'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.OUT_HOUSE_SETTLEMENT_QUEUE.value,
    title: WORK_QUEUE.OUT_HOUSE_SETTLEMENT_QUEUE.text,
    key: WORK_QUEUE.OUT_HOUSE_SETTLEMENT_QUEUE.key,
    features: WORK_QUEUE.OUT_HOUSE_SETTLEMENT_QUEUE.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_SETTLEMENT_QUEUE,
    color: ['#14565F', '#EFFFF7'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
export default THIRD_QUEUE
